import { render, staticRenderFns } from "./welfareSuccess.vue?vue&type=template&id=ce64b6d0"
import script from "./welfareSuccess.vue?vue&type=script&lang=js"
export * from "./welfareSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports